var _path, _mask, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningIcon = function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EABF29",
    d: "M8.539 2.973c1.538-2.63 5.325-2.63 6.864 0l8.042 14C25.005 19.64 23.091 23 20.013 23H3.987C.909 23-1.005 19.64.555 16.973z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "warningIcon_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13 6a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0zm-1 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13 6a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0zm-1 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 6h2a2 2 0 0 0-2-2zm0 0V4a2 2 0 0 0-2 2zm0 8V6h-2v8zm0 0h-2a2 2 0 0 0 2 2zm0 0v2a2 2 0 0 0 2-2zm0-8v8h2V6zm0 12v2a2 2 0 0 0 2-2zm0 0h2a2 2 0 0 0-2-2zm0 0v-2a2 2 0 0 0-2 2zm0 0h-2a2 2 0 0 0 2 2z",
    mask: "url(#warningIcon_svg__a)"
  })));
};
export default SvgWarningIcon;